
import api from '../api';



const getStore = async (storeId) => {
  try {
    const response = await api.get(`/wapi/store/${encodeURIComponent(storeId)}`);

    return response.data;

  } catch (error) {
    console.error(error)
    throw error;
  }
}; // Removed requestData from dependencies


export default getStore;
